<template>
    <div class="col-12 text-justify">
        <h2 v-if="seccionDeLaPaginaWeb.MostrarNombreDeLaSeccion == true" class="my-4 letraDelTitulo text-left">{{seccionDeLaPaginaWeb.NombreDeLaSeccion}}</h2>
        <h5 v-if="seccionDeLaPaginaWeb.TextoDePresentacion != null" class="page-text col-12 px-5 my-3">{{seccionDeLaPaginaWeb.TextoDePresentacion}}</h5>
        <h6 v-if="seccionDeLaPaginaWeb.Subtitulo != null" class="page-text letraDelTitulo col-12 px-5 my-3 text-left">{{seccionDeLaPaginaWeb.Subtitulo}}</h6>
        <TocasElectorales v-if="seccionDeLaPaginaWeb.TipoFormato.TipoFormatoId == enumeraciones_sicpo.TiposFormatos.TocasElectorales" :seccionDeLaPaginaWeb="seccionDeLaPaginaWeb"></TocasElectorales>
        <div v-else-if="seccionDeLaPaginaWeb.SeccionesQueMePertenecen.length > 0" class="col-12">
            <!--Transparencia-->
            <Transparencia v-if="seccionDeLaPaginaWeb.TipoFormato.TipoFormatoId == enumeraciones_sicpo.TiposFormatos.Transparencia" :seccionDeLaPaginaWeb="seccionDeLaPaginaWeb"></Transparencia>
            <Seccion v-else v-for="seccion in seccionDeLaPaginaWeb.SeccionesQueMePertenecen" v-bind:key="seccion.SeccionDeLaPaginaWebId" :seccionDeLaPaginaWeb="seccion" :nombreDelComponente="'seccion_' + seccion.SeccionDeLaPaginaWebId"></Seccion>
        </div>
        <div v-else class="col-12 cargaLosBrincosDeLineaEnHTML">
            <!--Listado de vinculos-->
            <ListadoDeVinculos v-if="seccionDeLaPaginaWeb.TipoFormato.TipoFormatoId == enumeraciones_sicpo.TiposFormatos.ListaDeVinculos" :seccionDeLaPaginaWeb="seccionDeLaPaginaWeb"></ListadoDeVinculos>
            <!--Cartas con vinculos-->
            <CartasConVinculos v-else-if="seccionDeLaPaginaWeb.TipoFormato.TipoFormatoId == enumeraciones_sicpo.TiposFormatos.CartasConVinculos" :seccionDeLaPaginaWeb="seccionDeLaPaginaWeb"></CartasConVinculos>
            <!--Tabla con vinculos-->
            <TablaConVinculos v-else-if="seccionDeLaPaginaWeb.TipoFormato.TipoFormatoId == enumeraciones_sicpo.TiposFormatos.TablaDeVinculos" :seccionDeLaPaginaWeb="seccionDeLaPaginaWeb"></TablaConVinculos>
            <!--Modal con vinculos-->
            <VinculoConModal v-else-if="seccionDeLaPaginaWeb.TipoFormato.TipoFormatoId == enumeraciones_sicpo.TiposFormatos.VinculoConModal" :seccionDeLaPaginaWeb="seccionDeLaPaginaWeb"></VinculoConModal>
            <!--Tabla con texto-->
            <TablaConTexto v-else-if="seccionDeLaPaginaWeb.TipoFormato.TipoFormatoId == enumeraciones_sicpo.TiposFormatos.TablaConTexto" :seccionDeLaPaginaWeb="seccionDeLaPaginaWeb"></TablaConTexto>
            <!--Embebido-->
            <Embebido v-else-if="seccionDeLaPaginaWeb.TipoFormato.TipoFormatoId == enumeraciones_sicpo.TiposFormatos.Embebido" :seccionDeLaPaginaWeb="seccionDeLaPaginaWeb"></Embebido>
            <!--Texto y boton con vinculo-->
            <TextoYBotonConVinculo v-else-if="seccionDeLaPaginaWeb.TipoFormato.TipoFormatoId == enumeraciones_sicpo.TiposFormatos.TextoYBotonConVinculo" :seccionDeLaPaginaWeb="seccionDeLaPaginaWeb"></TextoYBotonConVinculo>
            <!--Carrusel con contexto-->
            <CarruselConContexto v-else-if="seccionDeLaPaginaWeb.TipoFormato.TipoFormatoId == enumeraciones_sicpo.TiposFormatos.CarruselConContexto" :seccionDeLaPaginaWeb="seccionDeLaPaginaWeb"></CarruselConContexto>
            <!--Solo texto-->
            <SoloTexto v-else-if="seccionDeLaPaginaWeb.TipoFormato.TipoFormatoId == enumeraciones_sicpo.TiposFormatos.SoloTexto" :seccionDeLaPaginaWeb="seccionDeLaPaginaWeb"></SoloTexto>
            <ConsultaDeCedulas v-else-if="seccionDeLaPaginaWeb.TipoFormato.TipoFormatoId == enumeraciones_sicpo.TiposFormatos.NotificacionesCiviles" :seccionDeLaPaginaWeb="seccionDeLaPaginaWeb"></ConsultaDeCedulas>
            <BolsaTrabajo v-else-if="seccionDeLaPaginaWeb.TipoFormato.TipoFormatoId == enumeraciones_sicpo.TiposFormatos.BOLSA_DE_TRABAJO" :seccionDeLaPaginaWeb="seccionDeLaPaginaWeb"></BolsaTrabajo>
            <ConsultaSentencias v-else-if="seccionDeLaPaginaWeb.TipoFormato.TipoFormatoId == enumeraciones_sicpo.TiposFormatos.ConsultaPublicaSentencias" :seccionDeLaPaginaWeb="seccionDeLaPaginaWeb"></ConsultaSentencias>
            <ConsultaPublicaAudiencias v-else-if="seccionDeLaPaginaWeb.TipoFormato.TipoFormatoId == enumeraciones_sicpo.TiposFormatos.ConsultaPublicaAudiencias" :seccionDeLaPaginaWeb="seccionDeLaPaginaWeb"></ConsultaPublicaAudiencias>
             <ConvocatoriasFormulario v-else-if="seccionDeLaPaginaWeb.TipoFormato.TipoFormatoId == 48" :seccionDeLaPaginaWeb="seccionDeLaPaginaWeb"></ConvocatoriasFormulario>
             <ConvocatoriasDisponibles v-else-if="seccionDeLaPaginaWeb.TipoFormato.TipoFormatoId == 51"></ConvocatoriasDisponibles>
             <ValidacionDocumentoFirmado v-else-if="seccionDeLaPaginaWeb.TipoFormato.TipoFormatoId == 52"></ValidacionDocumentoFirmado>
            <!--En caso de que el formato no exista-->
            <h3 v-else class=" col-12 errorAlCargarElFormato">El formato de la pagina no se cargo correctamente.</h3>
        </div>
    </div>
</template>

<script>
import enumeraciones_sicpo from "@/../static/js/enumeraciones/sicpo.js";

import Seccion from "@/components/PaginaOficial/PaginaInformativa/Seccion.vue"

import ListadoDeVinculos from "@/components/PaginaOficial/PaginaInformativa/Formatos/ListadoDeVinculos.vue"
import CartasConVinculos from "@/components/PaginaOficial/PaginaInformativa/Formatos/CartasConVinculos.vue"
import TablaConVinculos from "@/components/PaginaOficial/PaginaInformativa/Formatos/TablaConVinculos.vue"
import VinculoConModal from "@/components/PaginaOficial/PaginaInformativa/Formatos/VinculoConModal.vue"
import TablaConTexto from "@/components/PaginaOficial/PaginaInformativa/Formatos/TablaConTexto.vue"
import Transparencia from "@/components/PaginaOficial/PaginaInformativa/Formatos/Transparencia.vue"
import Embebido from "@/components/PaginaOficial/PaginaInformativa/Formatos/Embebido.vue"
import TextoYBotonConVinculo from "@/components/PaginaOficial/PaginaInformativa/Formatos/TextoYBotonConVinculo.vue"
import CarruselConContexto from "@/components/PaginaOficial/PaginaInformativa/Formatos/CarruselConContexto.vue"
import SoloTexto from "@/components/PaginaOficial/PaginaInformativa/Formatos/SoloTexto.vue"
import TocasElectorales from "@/components/PaginaOficial/PaginaInformativa/Formatos/TocasElectorales.vue"
import ConsultaDeCedulas from "@/components/PaginaOficial/PaginaInformativa/Notificaciones/Civiles/ConsultaDeCedulas.vue"
import ConsultaSentencias from "@/components/SICSEN/Consulta/ConsultaPublicaSentencias.vue"
import ConsultaPublicaAudiencias from "@/components/PaginaOficial/PaginaInformativa/Audiencias/Temporal/CConsultaPublica.vue"
import ConvocatoriasFormulario from "@/components/PaginaOficial/PaginaInformativa/Convocatorias/ConvocatoriasFormulario.vue"
import BolsaTrabajo from "@/components/PaginaOficial/PaginaInformativa/PaginasInformativas/BolsaDeTrabajo/CBolsaDeTrabajo.vue"
import ConvocatoriasDisponibles from "@/components/PaginaOficial/PaginaInformativa/Convocatorias/ConvocatoriasDisponibles.vue"
import ValidacionDocumentoFirmado from '@/components/PaginaOficial/Funciones/ValidaDocumentoFirmado/VistaValidaDocumentoFirmadoQR.vue'

export default {
    name: "Seccion",
    data() { 
      return {
        enumeraciones_sicpo
      }
    },
    components: {
        ListadoDeVinculos,
        CartasConVinculos,
        TablaConVinculos,
        VinculoConModal,
        TablaConTexto,
        Transparencia,
        Embebido,
        TextoYBotonConVinculo,
        CarruselConContexto,
        SoloTexto,
        TocasElectorales,
        Seccion,
        ConsultaDeCedulas,
    ConsultaSentencias,
    ConsultaPublicaAudiencias,
    ConvocatoriasFormulario,
    BolsaTrabajo,
    ConvocatoriasDisponibles,
    ValidacionDocumentoFirmado
    },
    props: {
        seccionDeLaPaginaWeb: Object, 
        nombreDelComponente: String
    }
}
</script>

<style scoped>
  .cargaLosBrincosDeLineaEnHTML {
    white-space: pre-line;
  }

  .errorAlCargarElFormato {
    padding-top: 30px;
  }
</style>



// WEBPACK FOOTER //
// src/components/PaginaOficial/PaginaInformativa/Seccion.vue